const inFlight = new Map();

const SCHEDULED_METHODS = new Set(['get', 'head']);

const buildKey = (config = {}) => {
  const method = String(config.method || 'get').toLowerCase();
  const url = config.url || '';
  const params = JSON.stringify(config.params || {});
  return `${method.toUpperCase()}::${url}::${params}`;
};

const shouldSchedule = (config = {}) => {
  if (config._skipScheduler === true) return false;
  return SCHEDULED_METHODS.has(String(config.method || 'get').toLowerCase());
};

export const globalApiScheduler = {
  request(axiosRequest, config = {}) {
    if (!shouldSchedule(config)) {
      return axiosRequest(config);
    }

    const key = buildKey(config);
    const existing = inFlight.get(key);
    if (existing) {
      return existing.promise;
    }

    const controller = new AbortController();
    const callerSignal = config.signal;
    if (callerSignal) {
      if (callerSignal.aborted) {
        controller.abort();
      } else {
        callerSignal.addEventListener('abort', () => controller.abort(), { once: true });
      }
    }

    const promise = axiosRequest({
      ...config,
      signal: controller.signal
    }).finally(() => {
      inFlight.delete(key);
    });

    inFlight.set(key, { controller, promise });
    return promise;
  },

  cancel(key) {
    const request = inFlight.get(key);
    if (request) {
      request.controller.abort();
      inFlight.delete(key);
    }
  },

  cancelAll() {
    inFlight.forEach(({ controller }) => controller.abort());
    inFlight.clear();
  }
};
